import { CommunicationsSettingsBase } from './notifications-settings-base.model';

export class SmsNotificationsSettings extends CommunicationsSettingsBase {
    title: string;
    message: string;
    messageWithLineBreaks: string;
}
